import { z } from 'zod';

export enum ErroOrigem {
    Todos = 0,
    Backend = 1,
    Frontend = 2,
    MercurioLocal = 3,
    Lacto = 4,
    MercurioImpressao = 5,
    Outros = 99,
}

export const ErroSchema = z.object({
    err_conteudo: z.string(),
    err_idpk: z.number(),
    err_origem: z.enum(ErroOrigem),
    err_ultima_alteracao: z.string().nullable(),
});

export type Erro = z.infer<typeof ErroSchema>;
